import { GridContainer } from 'libs/ui';
import { Discount } from 'grids/discount/discount';

export const DiscountsWrapper = (props) => {
  return (
    <GridContainer>
      <Discount {...props} />
    </GridContainer>
  );
};
